// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"fcc7d17c","822":"8a0bb9d9","874":"37b20f07"}[chunkId] + ".chunk.css";
};